import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { AppEventService } from 'src/app/services/app-event-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent  implements OnInit {
  // Header Properties
  @Input() translucent: boolean = false;
  @Input() customClass: string = '';

  @Input() showMenuButton: boolean = true;
  @Input() showBackButton: boolean = false;
  @Input() showLogo: boolean = true;
  
  // Events
  @Output() menuClick = new EventEmitter<void>();
  @Output() backClick = new EventEmitter<void>();

  logInStatus: boolean = false;

  constructor(private menuCtrl: MenuController, private appEvents: AppEventService) { }

  ngOnInit() {}

  async onMenuClick() {
    await this.menuCtrl.open('main-menu');
    this.appEvents.notifyMenuClicked();
  }
  
  onBackClick() {
    window.history.back();
  }
  
}
